import ApiService from '../apiservice'

export default class TransferenciaFinanceiraService extends ApiService {
  constructor() {
    super('/transferencia-financeira');
  }

  incluirArquivo(formData) {
    return this.post('/arquivo',formData);
  }

  transferir(transferencia) {
    return this.post('/transferir',transferencia);
  }

  consultarTransferencias(filtro) {
    return this.get(`/consultar-transferencias?empresa=${filtro.empresa}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&conta=${filtro.conta}&tipo=${filtro.tipo}&codigo=${filtro.codigo}`);
  }
}